module.exports = __webpack_public_path__ + "static/media/leasing.b7de3afa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leasing.svg
// module id = 1290
// module chunks = 0